import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';

import { deleteFormulaEntry } from '../api/formula-library.api';
import { FORMULA_ENTRIES_QUERY_KEY } from '../constants/reports-query-keys';

export const useDeleteFormulaEntry = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: (id: string) => deleteFormulaEntry(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORMULA_ENTRIES_QUERY_KEY });
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(
        error,
        'authenticated.reports:toasts.formulaDeleteError'
      );
    },
  });
};
